const QUERY_COSTS_LIMITS =
{
    OPTIMAL: 6079,
    NORMAL: 16607,
    HIGH: 45560
}

export default QUERY_COSTS_LIMITS
